"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowEditTab = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const workflow_1 = require("@sierralabs/workflow");
const EditableFieldSection_1 = __importDefault(require("../components/EditableFieldSection"));
const GroupPermissionsSection_1 = __importDefault(require("../components/GroupPermissionsSection"));
const StateEventEditorContainer_1 = __importDefault(require("../components/StateEventEditorContainer"));
const StateInvokeActionEditor_1 = __importDefault(require("../components/StateInvokeActionEditor"));
const useUpdateWorkflowConfig_1 = require("../hooks/useUpdateWorkflowConfig");
const ColorPicker_1 = __importDefault(require("../pickers/ColorPicker"));
const StateNodeTypePicker_1 = __importDefault(require("../pickers/StateNodeTypePicker"));
const StyledSplitPane = (0, styled_components_1.default)(core_ui_1.SplitPane) `
  .resizer {
    z-index: 1;
  }
  .helper-text {
    padding-left: 8px;
    white-space: initial;
  }
`;
const StyledEditorPane = (0, styled_components_1.default)(core_ui_1.Pane) `
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
`;
const StyledConfigurator = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 64px;
  background: #fff;
  .config-content {
    padding: 10px;
    margin-bottom: 10px;
  }
  .form-fields {
    display: flex;
    flex-direction: column;
    width: 100%;
    .field {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
`;
const WorkflowEditTab = props => {
    var _a, _b, _c;
    const { workflow: workflowDto, onChange } = props;
    const shouldRefreshRef = (0, react_1.useRef)(false);
    const didSetWorkflowRef = (0, react_1.useRef)(false);
    const [debounceRefresh] = (0, core_ui_1.useTimeout)();
    const [, setDiagram] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)();
    const [{ workflow }, setWorkflowState] = (0, react_1.useState)({ workflow: undefined });
    const [{ shape: selectedShape }, setSelectedShapeState] = (0, react_1.useState)({ shape: undefined });
    const { data: updatedWorkflow, error: updateError, updateWorkflowConfig } = (0, useUpdateWorkflowConfig_1.useUpdateWorkflowConfig)((workflowDto === null || workflowDto === void 0 ? void 0 : workflowDto.id) || 0);
    const updateShape = () => {
        setSelectedShapeState({ shape: selectedShape });
    };
    const updateWorkflow = (shouldRefresh = true) => {
        if (workflow) {
            const workflowJson = workflow.toJson();
            console.log('[updateWorkflow]', workflowJson);
            updateWorkflowConfig(workflowJson);
            if (shouldRefresh) {
                setWorkflowState({ workflow });
            }
        }
    };
    const onShapeChange = () => {
        updateShape();
        updateWorkflow();
    };
    // get the config for the current workflow being edited
    (0, react_1.useEffect)(() => {
        var _a;
        // only call this effect once to avoid updating shape references
        if (didSetWorkflowRef.current) {
            return;
        }
        didSetWorkflowRef.current = true;
        // handle empty object
        const config = ((_a = workflowDto.config) === null || _a === void 0 ? void 0 : _a.states)
            ? workflowDto.config
            : { name: workflowDto.name, states: [{ name: 'Untitled' }] };
        setWorkflowState({ workflow: new workflow_1.Workflow(config) });
    }, [workflowDto.config, workflowDto.name]);
    (0, react_1.useEffect)(() => {
        if (updatedWorkflow) {
            const config = workflow === null || workflow === void 0 ? void 0 : workflow.toJson();
            if (config) {
                onChange === null || onChange === void 0 ? void 0 : onChange({ config });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updatedWorkflow]);
    (0, react_1.useEffect)(() => {
        updateError && setError(updateError);
    }, [updateError]);
    return (react_1.default.createElement(StyledSplitPane, { primary: 'next', className: 'workflow-edit-tab' },
        react_1.default.createElement(StyledEditorPane, { flex: true, className: 'editor-container' }, workflow && (react_1.default.createElement(workflow_1.WorkflowDiagram, { workflow: workflow, type: workflow_1.DiagramType.State, onShapeChange: onShapeChange, onDiagramLoad: diagram => {
                setDiagram(diagram);
                if (!shouldRefreshRef.current) {
                    return;
                }
                // refresh connectors
                shouldRefreshRef.current = false;
                const { shapes } = diagram.shape;
                diagram.shape.shapes = [];
                diagram.refresh();
                debounceRefresh(() => {
                    diagram.shape.shapes = shapes;
                    diagram.refresh();
                });
            }, onSelectionChange: shape => {
                setSelectedShapeState({
                    shape: shape.type === workflow_1.ShapeType.State ? shape : undefined
                });
            }, onDelete: () => {
                if (workflow.stateNode.states.length === 0) {
                    workflow.stateNode.addState();
                }
                setSelectedShapeState({ shape: undefined });
                updateWorkflow();
            } }))),
        react_1.default.createElement(core_ui_1.SplitPane, { width: 300 }, workflow &&
            selectedShape &&
            selectedShape instanceof workflow_1.Shape &&
            selectedShape.data && (react_1.default.createElement(StyledConfigurator, null,
            react_1.default.createElement(core_ui_1.ConfigCard, null,
                react_1.default.createElement(core_ui_1.ConfigHeader, null, "Info"),
                react_1.default.createElement(core_ui_1.ConfigContent, null,
                    react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
                        react_1.default.createElement(core_1.TextField, { fullWidth: true, label: 'Name', className: 'field', variant: 'outlined', value: selectedShape.name, onChange: event => {
                                selectedShape.name = event.target.value;
                                if (selectedShape.data) {
                                    workflow.renameStateNode(selectedShape.data, event.target.value);
                                }
                                updateShape();
                            }, onBlur: () => updateWorkflow() })),
                    react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
                        react_1.default.createElement(StateNodeTypePicker_1.default, { value: (_a = selectedShape.data) === null || _a === void 0 ? void 0 : _a.type, onChange: type => {
                                if (selectedShape.data instanceof workflow_1.StateNode) {
                                    selectedShape.data.type = type;
                                    selectedShape.data.refreshType();
                                    updateShape();
                                    updateWorkflow();
                                }
                            } })))),
            react_1.default.createElement(GroupPermissionsSection_1.default, { shape: selectedShape, onChange: groups => {
                    if (!(selectedShape.data instanceof workflow_1.StateNode)) {
                        return;
                    }
                    if (!selectedShape.data.meta) {
                        selectedShape.data.meta = {};
                    }
                    if (!Array.isArray(selectedShape.data.meta.groupPermissions)) {
                        selectedShape.data.meta.groupPermissions = [];
                    }
                    // save group ids
                    const groupIds = groups.map(group => group.id);
                    const { groupPermissions } = selectedShape.data.meta;
                    groupPermissions.splice(0, groupPermissions.length);
                    groupPermissions.push(...groupIds);
                    updateShape();
                    updateWorkflow();
                } }),
            react_1.default.createElement(EditableFieldSection_1.default, { shape: selectedShape, workflowDto: workflowDto, onChange: fields => {
                    if (!(selectedShape.data instanceof workflow_1.StateNode)) {
                        return;
                    }
                    // set meta and allowedFields if not existing
                    if (!selectedShape.data.meta) {
                        selectedShape.data.meta = {};
                    }
                    if (!Array.isArray(selectedShape.data.meta.allowedFields)) {
                        selectedShape.data.meta.allowedFields = [];
                    }
                    const { allowedFields } = selectedShape.data.meta;
                    allowedFields.splice(0, allowedFields.length);
                    allowedFields.push(...fields);
                    updateShape();
                    updateWorkflow();
                } }),
            react_1.default.createElement(core_ui_1.ConfigCard, null,
                react_1.default.createElement(core_ui_1.ConfigHeader, null, "Color"),
                react_1.default.createElement(core_ui_1.ConfigContent, null,
                    react_1.default.createElement(ColorPicker_1.default, { color: (_c = (_b = selectedShape === null || selectedShape === void 0 ? void 0 : selectedShape.data) === null || _b === void 0 ? void 0 : _b.meta) === null || _c === void 0 ? void 0 : _c.color, onChange: color => {
                            if ((selectedShape === null || selectedShape === void 0 ? void 0 : selectedShape.data) instanceof workflow_1.StateNode) {
                                if (typeof selectedShape.data.meta === 'undefined') {
                                    selectedShape.data.meta = {};
                                }
                                selectedShape.data.meta.color = color;
                                updateShape();
                                updateWorkflow();
                            }
                        } }))),
            react_1.default.createElement(StateEventEditorContainer_1.default, { shape: selectedShape, editorProps: {
                    workflow,
                    taskTypeId: workflowDto.taskTypeId,
                    updateShape,
                    updateWorkflow
                }, onChange: () => updateWorkflow() }),
            react_1.default.createElement(StateInvokeActionEditor_1.default, { shape: selectedShape, taskTypeId: workflowDto.taskTypeId, onChange: () => {
                    updateShape();
                    updateWorkflow();
                } })))),
        react_1.default.createElement(core_ui_1.AppSnackbar, { open: !!error, severity: 'error', onClose: () => setError(undefined) }, error === null || error === void 0 ? void 0 : error.message)));
};
exports.WorkflowEditTab = WorkflowEditTab;
exports.default = exports.WorkflowEditTab;
//# sourceMappingURL=WorkflowEditTab.js.map